export default __webpack_public_path__ + "static/media/logo-pricelocq.573e45fb.svg";